module.exports = __webpack_public_path__ + "img/_0.89cb34fe.png";